import './ServicesMain.css'
import React  from 'react';
import Tiles from './Tiles'
import Carousel from 'react-elastic-carousel';
import Backend from '../../assets/jpg/backend.jpg'
import WebDev from '../../assets/jpg/webdev.jpg'
import AppDev from '../../assets/jpg/mobdev.jpg'
import Graphics from '../../assets/jpg/graphic.jpg'
import Law from '../../assets/jpg/law.jpg'
import Pm from '../../assets/jpg/pm.jpg'
import Gd from '../../assets/jpg/gd.jpg'




const appdev = ["Android" , "iOS" , "Flutter" , "Native" , "Hybrid" , "Ionic"];
const webdev = ["Responsive" , "E-commerce" , "React" , "CSS" , "HTML"];
const backdev = ["SQL" ,  "Serverless" , "Kafka", "APIs"  , "Kafka" , "Event-driven"  , "Mongo"];
const prod = [ "User flows", "Ideation" , "Wireframing" ,  "Roadmaps"   , "Data insights"];
const graphic = ["Publishing", "Branding" ,   "Product", "Website" , "Print", "Animation"];
const game = ["Unity" , "Unreal" ,  "Mobile" , "PC"  , "Console", "Multiplayer"];
const legal = ["Liability Protection" , "Mergers" , "Corporate", "Acquisitions", "Entity Formations" ];



const Services = (props) => {
  const carouselRef = React.useRef(null);
  const onNextStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(0);
    }
  };
  const onPrevStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(11);
    }
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 }, 
  { width: 550, itemsToShow: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 4 }
  ]
 
    return (
        <div className="container-fluid mt-3 pt-5 serviceContainer " 
        ref = {props.refer}  >
        <div className="container" style = {{marginTop:"-200px",}}>
          <div className="row mt-5 text-center" >
            <div className="col-12 " >
            <h1 className="services" style = {{ color : 'white',textAlign : 'center' , fontSize : '54px' , fontFamily :'Poppins'}} > Services </h1>
            </div>
          </div>
          <div className="row text-center" >
            <div className="col-12" >
              <h2 className="serviceText" style = {{ color : 'white',textAlign : 'center' , fontFamily :'karla' , fontSize : '1.5vw'}}> 
              We offer end to end services throughout the product lifecycle and even beyond that.
            </h2>
            </div>
          </div>
          </div>
          <div className = 'tilesContainer mt-5'>
          <Carousel className="carouselService" breakPoints = {breakPoints}  
          ref = {carouselRef} onPrevStart={onPrevStart} onNextStart={onNextStart} disableArrowsOnEnd={false} enableMouseSwipe = {true} key = {true}>
          <Tiles headline = "Website Development"  Arr = {webdev} myImage = {WebDev} />  
          <Tiles headline = "App Development"  Arr = {appdev} myImage = {AppDev} /> 
          <Tiles headline = "Backend Development"  Arr = {backdev} myImage = {Backend} /> 
          <Tiles headline = "Product Management"  Arr = {prod} myImage = {Pm} /> 
          <Tiles headline = "Graphic Designing"  Arr = {graphic} myImage = {Graphics} /> 
          <Tiles headline = "Game Development"  Arr = {game} myImage = {Gd} /> 
          <Tiles headline = "Legal Support"  Arr = {legal} myImage = {Law} /> 
          </Carousel>
          </div>
          <div ref = {props.refer2}> </div>
        </div>  
    )
}

export default Services
